import { useState } from "react";
import emailjs from "@emailjs/browser";
import NavBar from "./NavBar";
import "./ContactUs.css";

const EMAILJS_SERVICE_ID = "service_uk1s0mp";
const EMAILJS_TEMPLATE_ID = "template_lngs7vk";
const EMAILJS_PUBLIC_KEY = "hGxpN7VWtQgODObXP";

function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    province: "",
    areaOfInterest: "",
    heardAboutUs: "",
    message: "",
  });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          province: formData.province,
          area_of_interest: formData.areaOfInterest,
          heard_about_us: formData.heardAboutUs,
          message: formData.message,
        },
        EMAILJS_PUBLIC_KEY,
      )
      .then(() => {
        setStatus("success");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          province: "",
          areaOfInterest: "",
          heardAboutUs: "",
          preferredLanguage: "",
          message: "",
        });
      })
      .catch(() => {
        setStatus("error");
      });
  };

  return (
    <div className="ContactUs">
      <NavBar />

      <div className="PageTitleBanner">
        <h1>Contact Us</h1>
      </div>

      <div className="ContactFormSection">
        <form className="ContactForm" onSubmit={handleSubmit}>
          <div className="FormRow">
            <div className="FormField">
              <input
                type="text"
                name="firstName"
                placeholder="First Name *"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="FormField">
              <input
                type="text"
                name="lastName"
                placeholder="Last Name *"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="FormRow">
            <div className="FormField">
              <input
                type="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="FormField">
              <input
                type="tel"
                name="phone"
                placeholder="Phone *"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="FormRow">
            <div className="FormField">
              <label className="SelectLabel">
                Please select your province <span className="Required">*</span>
              </label>
              <select
                name="province"
                value={formData.province}
                onChange={handleChange}
                required
              >
                <option value=""></option>
                <option value="eastern-cape">Eastern Cape</option>
                <option value="free-state">Free State</option>
                <option value="gauteng">Gauteng</option>
                <option value="kwazulu-natal">KwaZulu-Natal</option>
                <option value="limpopo">Limpopo</option>
                <option value="mpumalanga">Mpumalanga</option>
                <option value="north-west">North West</option>
                <option value="northern-cape">Northern Cape</option>
                <option value="western-cape">Western Cape</option>
              </select>
            </div>
            <div className="FormField">
              <label className="SelectLabel">
                Area of Interest <span className="Required">*</span>
              </label>
              <select
                name="areaOfInterest"
                value={formData.areaOfInterest}
                onChange={handleChange}
                required
              >
                <option value=""></option>
                <option value="investment-management">
                  Investment Management
                </option>
                <option value="wealth-planning">Wealth Planning</option>
                <option value="retirement-planning">Retirement Planning</option>
                <option value="offshore-investments">
                  Offshore Investments
                </option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="FormRow FormRowFull">
            <div className="FormField">
              <select
                name="heardAboutUs"
                value={formData.heardAboutUs}
                onChange={handleChange}
                required
              >
                <option value="">Where did you hear about us? *</option>
                <option value="referral">Referral</option>
                <option value="google">Google</option>
                <option value="social-media">Social Media</option>
                <option value="event">Event</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="FormRow FormRowFull">
            <div className="FormField">
              <textarea
                name="message"
                placeholder="How can we assist you? *"
                value={formData.message}
                onChange={handleChange}
                rows="6"
                required
              />
            </div>
          </div>

          <div className="FormRow FormRowFull">
            <button
              type="submit"
              className="SubmitButton"
              disabled={status === "sending"}
            >
              {status === "sending" ? "Sending..." : "Submit"}
            </button>
          </div>

          {status === "success" && (
            <p className="FormSuccess">Thank you! We'll be in touch soon.</p>
          )}
          {status === "error" && (
            <p className="FormError">
              Something went wrong. Please try again or email us directly.
            </p>
          )}
        </form>
      </div>
      <footer className="ComplianceFooter">
        <p>
          Oakmere Capital is a Juristic Representative of Yellowwood Private
          Wealth. Yellowwood Private Wealth is an authorised financial services
          provider.
        </p>
        <p>FSP No 49879</p>
        <p>
          Copies of our complaints and conflicts of interest policies are
          available upon request.
        </p>
      </footer>
    </div>
  );
}

export default ContactUs;
